import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './helpers/store';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import labeli18n from './i18n/labeli18n';

syncTranslationWithStore(store);
store.dispatch(loadTranslations(labeli18n));
store.dispatch(setLocale('es'));

const rootComponent = (
    <Provider store={store}>
            <App />
    </Provider>
);

ReactDOM.render(rootComponent,document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
